module.exports = __webpack_public_path__ + "media/clip_10.0ac27f68.mp4";